import { handleActions } from 'redux-actions'
import * as actions from '@/store/action/common/'
const commonReducer = handleActions({
    [actions.resetFetchState]: (state, action) => ({
        ...state,
        ...action.payload
    }),
    // 获取工具列表
    [actions.getValidToolListSuccess]: (state, action) => {
        return {
            ...state,
            getValidToolList: action.payload.tools || [],
            getValidToolListSuccess: true
        }
    },
    //获取权限点接口
    [actions.getPermissionsSuccess]: (state, action) => {
        let permissions = action.payload.data || []
        return {
            ...state,
            permissions,
            getPermissionsSuccess: true
        }
    },

    //获取订单查询信息
    [actions.GetProviderSuccess]: (state, action) => {
        let getProvider = action.payload.data || []
        return {
            ...state,
            getProvider,
            GetProviderSuccess: true
        }
    },

    //获取工单 用户类型 业务线 渠道接口
    [actions.GetTicketOptionsSuccess]: (state, action) => {
        let {data} = action.payload
        return {
            ...state,
            businessTypeList: data && data[0].field.values.filter((item)=> item.active),
            // channelList: data[1].field.values.filter((item)=> item.active && item.actionList && item.actionList.includes('ticket_create')),
            channelList: data && data[1].field.values.filter((item)=> item.active),
            requesterTypeList: data && data[2].field.values,
        }
    },
    //获取 城市列表
    [actions.GetAllCitySuccess]: (state, action) => {
        // 城市列表 加入N/A
        const cityNA = {
            area: -1,
            enName: "N/A",
            id: -1,
            name: "N/A",
        }
        let cityList = action.payload?.data?.cityList || []
        cityList.unshift(cityNA)
        return {
            ...state,
            cityList
        }
    },
    //获取  分组列表
    [actions.getAllUserGroupsSuccess]: (state, action) => {
        let groupList = action.payload.list || []
        return {
            ...state,
            groupList
        }
    },
    //获取  电话前缀 列表
    [actions.GetPhonePrefixSuccess]: (state, action) => {
        let countryList = action.payload.country_list || []
        let openCountryList = action.payload.open_country_list || []
        return {
            ...state,
            countryList,
            openCountryList
        }
    }

}, actions.initStateData)

export default commonReducer
